










import { defineComponent, computed, watchEffect, watch } from '@vue/composition-api';
import Mousetrap from 'mousetrap';

import store from '@/store';
import GlobalSnackbar from '@/components/GlobalSnackbar/Snackbar.vue';
import Prompt from '@/components/Prompt/Prompt.vue';
import MigrationNotice from '@/components/MigrationNotice.vue';
import UploadProgressDisplay from '@/components/UploadProgressDisplay.vue';
import { AnnotationClassDefinition } from './types';
import { defaultAnnotationClass } from './utils';
import { loggedIn } from './utils/auth';
import { useClient } from './use';

export default defineComponent({
  name: 'App',
  components: { GlobalSnackbar, Prompt, MigrationNotice, UploadProgressDisplay },
  setup(props, ctx) {
    const dialogOpen = computed(() => store.state.application.dialogOpen);
    const dark = computed({
      get: () => store.state.application.darkTheme,
      set: (val) => { store.commit.application.setDarkTheme(val); },
    });

    watch(dialogOpen, (val) => {
      if (val) {
        Mousetrap.pause();
      } else {
        Mousetrap.unpause();
      }
    });

    // Needed to link the theme config in ctx.root and store
    watchEffect(() => {
      // eslint-disable-next-line no-param-reassign
      ctx.root.$vuetify.theme.dark = dark.value;
    });

    watch(loggedIn, async (val) => {
      if (!val) {
        return;
      }

      // Initialize ApplicationData
      const applicationData = await useClient().getApplicationData();

      // Initialize default annotation class if it's not present
      Object.keys(applicationData.subject_templates).forEach((key) => {
        const subjectTemplate = applicationData.subject_templates[key];
        const painMgsAnnotations: AnnotationClassDefinition[] | undefined = subjectTemplate['pain-mgs']?.annotations;

        // Don't insert if this class already exists
        const existingClass = painMgsAnnotations?.find(((annotationClass) => annotationClass.class === defaultAnnotationClass.class));
        if (existingClass !== undefined) {
          return;
        }

        // Add default class
        painMgsAnnotations.unshift(defaultAnnotationClass);
      });

      store.commit.application.setApplicationData(applicationData);
    });
  },
});
